// libs
import React, { useContext, memo } from 'react';

// context
import { OverlaySheetContext } from 'shared/components/OverlaySheet';

// styles
import {
  HeaderContainer,
  CloseIcon,
} from 'shared/components/OTPVerification/LoginNudge/component/Header/styles';

function Header() {
  const { doHide } = useContext(OverlaySheetContext);

  return (
    <HeaderContainer>
      <CloseIcon className="icon-cross" onClick={doHide} />
    </HeaderContainer>
  );
}

export default memo(Header);
